import React, { useCallback, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect, useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { MdKeyboardBackspace } from 'react-icons/md';
import { rem } from 'polished';
import styled from 'styled-components';
import { get, find } from 'lodash';
import { useQuery, useQueryClient, useMutation } from 'react-query';
import Carousel from '@brainhubeu/react-carousel';

import { gtmEvents, flatten, checkToken } from '../../utils';
import * as AuctionsActions from '../../store/actions/auction.actions';
import * as eventTrackingActions from '../../store/actions/event-tracking.actions';
import { TagFincredit } from '../../components/TagFincredit';

import {
  Box,
  Flex,
  ProgressTimer,
  Loading,
  Tabs,
  PhotoGallery,
  Layout,
  CarouselPhoto,
  Button,
} from '../../components';
import { getTaxIdList, changeTaxIdForAuction } from '../../services/taxids';
import { Select } from '../../components/Select';
import AppConstants from '../../constants/appConstants';
import {
  Summary,
  DocumentResearch,
  Section,
  DetailsTab,
  Appraiser,
  SummaryD2D,
  VehicleConditionsD2D,
} from './components';

import appConstants from '../../constants/appConstants';
import { ChangeTaxIdDialog } from '../../components/change-taxid-dialog';
import Modal from '../../components/enhanced/Modal';
import { Dialog } from '../../components/dialog';
import { TaxProfileIcon } from '../../components/tax-profile-icon';
import { TimingAuctionContextProvider } from '../../context/TimingAuctionContext';
import { toggleModal } from '../../store/actions/ui.actions';
import { GoAlert } from 'react-icons/go';
import {
  AUCTION_OFFER_KEY,
  AUCTION_BUY_KEY,
  AUCTION_AUTOMATIC_OFFER_KEY,
  TIEBREAKER_RULES_KEY,
  AUCTION_BUY_FOR,
} from '../../constants/modalConstants';
import { useTimer } from '../../hooks/useTimer';
import {
  VehicleInfoBanner,
  VehicleInformationsContainer,
  VehicleNameAndInfos,
  VehicleChronometerAndLastOffer,
  VehicleLastOfferLabel,
  VehicleLastOfferAndIsWinningStatus,
  VehicleLastOfferValue,
  VehicleIsWinningLabel,
  VehicleActions,
  Row,
  AlertIconImg,
  VehicleLastOfferResponsiveContainer,
  FeedbackAutoBidContainer,
  FeedbackAutoBidLabel,
  AutoBidRules,
  Content,
  Column,
  NewButton,
  Recommended,
  AvaliatorContent,
  TextEnding,
  TextEndingdiv,
  FavoriteDiv,
  PhotoCategoryButton,
  MainPhotoText,
  PhotoCategoryButtonContainer,
} from './styles';

import { useBid } from '../../hooks/useBid';
import AlertIcon from '../../images/icons/automaticOfferAlertIconDetailVehicle.svg';

import AutoBidAction from '../../components/BidActions/AutoBidAction';
import { useAutoBid } from '../../hooks/useAutoBid';
import { listAutoBidVehicles, listAllAutoBidVehicles } from '../../store/autobid/effects';
import { useFlag, useUnleashContext } from '@unleash/proxy-client-react';
import { createViews } from '../../store/createViews/effects.js';
import { removeViewStorage, viewedStorage } from '../../helpers/viewedStorage';

import { sendEvent } from '../../helpers/googleAnalytics';
import { useSegment } from '../../hooks/useSegment';
import { Temperature } from '../../components/Temperature';
import { formatPrice } from '../../utils/formatPrice.js';
import { PercentageTag } from '../../components/PercentageTag';
import { NewAppraiser } from './components/new/Appraiser/index.jsx';
import { NewSection } from './components/new/Section/index.jsx';
import { Tag } from '../../components/NewTag';

import { NewCarousel } from '../../components/NewCarousel/index.jsx';
import { authGet } from '../../utils/fecth-wrappers.js';
import { checkFinancingEnabled, loadCreditAvaible } from '../../services/fincredit.js';
import { fetchWhitelistSpecifications } from '../../utils/fecth-wrappers.js';
import SealsContainer from '../../components/SealsContainer';

import { DocumentedModificationD2D } from './components/DocumentedModificationD2D/DocumentedModificationD2D.jsx';
import { ReturnPolicyD2D } from './components/ReturnPolicyD2D/ReturnPolicyD2D.jsx';
import { VehicleD2DVideos } from './components/VehicleD2DVideos';
import { VehicleVideos } from './components/VehicleVideos';
import { CloseButton } from '../../components/enhanced/PhotoGallery/CloseButton.js';

import initAmplitude, { trackEvent } from '../../utils/amplitude';
import TopicSummary from '../../components/TopicSummary';
import { transformToSections, getEvaluationV2Photos } from '../../utils/details';
import Clipboard from '../../images/icons/Clipboard.svg';

const TumbContainer = styled.div`
  margin-top: 30px;
`;

const Tumbnail = styled(Carousel)`
  margin-top: 10px;
  .BrainhubCarouselItem {
    margin-right: 8px;
    opacity: 0.5;
    &:hover {
      opacity: 1;
    }
  }

  .BrainhubCarouselItem--active {
    opacity: 1;
    border: 2px solid #ffffff;
    border-radius: 4px;
  }

  img {
    height: 5rem;
    width: 100%;
    object-fit: cover;
    cursor: pointer;
    border-radius: 4px;
  }
`;

const trackGTM = (gtmEvent, auction, eTrackingActions) => {
  if (!auction.summary) return;
  eTrackingActions.trackAuctionEvent(gtmEvent, auction._id);
};

const photosCategory = [{ label: 'Fotos principais' }, { label: 'Fotos dos apontamentos' }];

const BackButton = styled(Button).attrs({
  variant: 'default',
  isRounded: true,
  fontSize: 1,
  height: { sm: rem(24), md: rem(34) },
  px: 2,
})`
  color: #ffffff !important;
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 2;
  background-color: rgba(3, 3, 3, 0.4);
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.14);
`;

const VIEW_STATUS = {
  IDLE: 0,
  CONFIRM_TAXID_CHANGE: 1,
  TAXID_CHANGE_SUCCESS: 2,
  TAXID_CHANGE_ERROR: 3,
};

const DetailsPage = ({
  history,
  auctionId,
  auctionsActions,
  eTrackingActions,
  selectAuction,
  auctionSelected,
  toggleModal,
  allAuctions,
  listAutoBidVehicles,
  listAllAutoBidVehicles,
  bidError,
  bidErrorMessage,
}) => {
  const [gallery, setGallery] = useState({
    show: false,
    slide: 0,
    images: [],
  });
  const [state, setState] = useState('loading');
  const [photoCategory, setPhotoCategory] = useState(0);
  const [status, setStatus] = useState({ name: VIEW_STATUS.IDLE, context: {} });
  const [changedTaxId, setChangedTaxId] = useState(null);
  const [mainGallery, setMainGallery] = useState({
    show: false,
    slide: 0,
  });
  const [size, setSize] = useState(window.screen.width);
  const [taxIdDialogChangeSuccess, setTaxIdDialogChangeSuccess] = useState(false);
  const [displaySimulationBanner, setDisplaySimulationBanner] = useState(false);
  const [fincreditInfo, setFincreditInfo] = useState();
  const [initialSummarryAmount, setInitialSummarryAmount] = useState(0);
  const [selectedGroup, setSelectedGroup] = useState('');
  const [whitelistDebug, setWhitelistDebug] = useState(null);

  const taxIdsQuery = useQuery('taxids', getTaxIdList);
  const queryClient = useQueryClient();

  const { currentOffer, currentOfferLabel } = useBid(auctionSelected);
  const { page, trackButtonClicked, trackCarouselInteraction } = useSegment();
  const [updatedAuction, setUpdatedAuction] = useState(auctionSelected);

  useEffect(() => {
    try {
      if (!allAuctions?.length || !auctionId) return;

      const auction = allAuctions.find(auction => auction._id === auctionId);

      if (!auction) {
        // console.warn(`Auction with id ${auctionId} not found in allAuctions`);
        return;
      }

      setUpdatedAuction(auction);
    } catch (error) {
      // console.error('Error finding auction:', error);
    }
  }, [allAuctions, auctionId]);

  // Update when auctionSelected changes independently
  useEffect(() => {
    if (auctionSelected && (!updatedAuction || updatedAuction?._id !== auctionSelected?._id)) {
      setUpdatedAuction(auctionSelected);
    }
    if (auctionSelected && auctionSelected?.summary?.hasD2D) {
      setUpdatedAuction(auctionSelected);
    }
  }, [auctionSelected]);

  const dispatch = useDispatch();

  window.addEventListener('resize', () => setSize(window.screen.width));

  const getD2DPhotos = d2dInfo => {
    if (!d2dInfo) return [];

    // Para D2D, o campo photos está dentro do additionalInfo
    if (d2dInfo.photos) {
      return Object.values(d2dInfo.photos).filter(
        url =>
          typeof url === 'string' &&
          (url.endsWith('.jpg') ||
            url.endsWith('.jpeg') ||
            url.endsWith('.png') ||
            url.endsWith('.webp'))
      );
    }

    // Caso alternativo: buscar diretamente nas propriedades de additionalInfo
    const photoURLs = Object.entries(d2dInfo)
      .filter(
        ([key, value]) =>
          typeof value === 'string' &&
          (value.endsWith('.jpg') ||
            value.endsWith('.jpeg') ||
            value.endsWith('.png') ||
            value.endsWith('.webp'))
      )
      .map(([key, url]) => url);

    return photoURLs;
  };

  const getCarouselPhotos = () => {
    if (!updatedAuction?.summary) return [];

    let photoUrls = [];

    if (updatedAuction?.summary?.hasD2D) {
      // Para D2D, usar updatedAuction (lógica antiga)
      photoUrls = getD2DPhotos(updatedAuction?.summary?.additionalInfo);
    } else {
      // Para veículos não-D2D, usar auctionSelected.summary (nova lógica - 12 fotos)
      const summaryData = auctionSelected?.summary || updatedAuction?.summary;
      
      // Filtro da galeria: inclui jpg, jpeg, png, webp
      photoUrls =
        summaryData?.photos?.filter(url => 
          typeof url === 'string' && 
          (url.endsWith('.jpg') ||
           url.endsWith('.jpeg') ||
           url.endsWith('.png') ||
           url.endsWith('.webp'))
        ) || [];

      // Fallback: Se não vier nada, tentar additionalInfo.photos ou updatedAuction.summary.photos
      if (photoUrls.length === 0) {
        if (updatedAuction?.summary?.additionalInfo?.photos) {
          photoUrls = updatedAuction?.summary?.additionalInfo?.photos.filter(
            url => typeof url === 'string' && !url.includes('vimeo')
          );
        } else if (updatedAuction?.summary?.photos) {
          photoUrls = updatedAuction?.summary?.photos.filter(
            url => typeof url === 'string' && !url.includes('vimeo')
          );
        }
      }
    }

    // Transformar as URLs em objetos com propriedade src
    // Isso garante compatibilidade com os diferentes componentes
    const formattedPhotos = photoUrls.map(url => {
      if (typeof url === 'object' && url.src) {
        // Já está no formato esperado
        return url;
      }
      // Converter para o formato esperado
      return { src: url, alt: '' };
    });

    return formattedPhotos;
  };

  const {
    currentAutoBidConfigured,
    isActiveAutoBid,
    maximumAutoBidBudget,
    tieWithEdits,
    tieWithoutEdits,
    noEditsAndDesconfigured,
  } = useAutoBid(auctionSelected?._id);

  const { user } = useSelector(state => state.authentication);
  const { payload } = useSelector(state => state.listAllAutoBidVehicles);

  const updateContext = useUnleashContext();

  const remainingTime = useMemo(() => auctionSelected.auction?.remainingTime, [
    auctionSelected.auction,
  ]);
  const { secondsLeft: currentAuctionDuration } = useTimer(remainingTime);

  const { summary, auction: auctionData } = auctionSelected;

  const enabled = useFlag('auto-bid');
  const enabledPrices = useFlag('fipe-web-prices');
  const enabledMoreViewedTag = useFlag('more-viewed-tag');
  const enabledNewInspectionPoints = useFlag('inspection-points');
  const enabledRecommended = useFlag('similarVehicles');
  const enabledSimulationBanner = useFlag('banner-simulacao');
  const enableSendSimulation = useFlag('leilao_financiamento');
  const enableVideo = useFlag('inspection-video');

  let auctionTaxProfile = {};
  let newTaxId = {};

  const isWinning = useMemo(() => auctionSelected?.auction?.winning, [
    auctionSelected?.auction?.winning,
  ]);

  const loser = !currentAutoBidConfigured?.isWinner || !isWinning;

  const greaterOrTie =
    !currentAutoBidConfigured?.tie || currentOffer >= currentAutoBidConfigured?.balance;

  const vehicleHasAutoBidActive = useMemo(
    () => find(payload, { inspectionId: auctionSelected?._id, autoBidStatus: 'ON' }),
    [payload, auctionSelected?._id]
  );

  const vehicleWithoutUpdateLimit = useMemo(
    () =>
      currentAutoBidConfigured?.autoBidStatus === 'OFF' &&
      currentAutoBidConfigured?.updateLimit === 2,
    [currentAutoBidConfigured?.autoBidStatus, currentAutoBidConfigured?.updateLimit]
  );

  const losingInBothWays = useMemo(
    () => isActiveAutoBid && currentAutoBidConfigured?.updateLimit !== 2 && loser && greaterOrTie,
    [isActiveAutoBid, currentAutoBidConfigured, loser, greaterOrTie]
  );

  const losingInBothWaysWithoutEdits = useMemo(
    () => isActiveAutoBid && currentAutoBidConfigured?.updateLimit === 2 && loser && greaterOrTie,
    [isActiveAutoBid, currentAuctionDuration, loser, greaterOrTie]
  );

  const noEditsInBothWays = useMemo(
    () =>
      isActiveAutoBid &&
      currentAutoBidConfigured?.updateLimit === 2 &&
      !loser &&
      !currentAutoBidConfigured?.tie,
    [isActiveAutoBid, currentAutoBidConfigured, loser]
  );

  const automaticToSingleOfferLosing = useMemo(
    () => !enabled && vehicleHasAutoBidActive?.balance >= currentOffer,
    [enabled, vehicleHasAutoBidActive, currentOffer]
  );

  const handleSingleOfferModal = useCallback(() => {
    selectAuction(auctionSelected, { remainingTime: currentAuctionDuration * 1000 });
    toggleModal({
      key: AUCTION_OFFER_KEY,
      show: true,
      extras: { section: 'details' },
    });
    trackGTM(gtmEvents.CTA_MAKE_OFFER_DETAILS, auctionSelected._id, eTrackingActions);
    trackButtonClicked(auctionSelected._id, 'singleBid', auctionSelected?.auctionId, 'details');

    // Rastrear evento de clique no botão de oferta avulsa
    trackEvent('click_single_bid', {
      dealershipId: user?.id,
      inspectionId: auctionSelected?._id,
      auctionId: auctionSelected?.auctionId,
      currentOffer: currentOffer,
    });
  }, [selectAuction, auctionSelected, toggleModal, currentAuctionDuration, trackButtonClicked]);

  const handleAutomaticOfferModal = useCallback(() => {
    selectAuction(auctionSelected, { remainingTime: currentAuctionDuration * 1000 });
    toggleModal({
      key: AUCTION_AUTOMATIC_OFFER_KEY,
      show: true,
      extras: { selectedAuction: auctionSelected, section: 'details' },
    });
    trackButtonClicked(auctionSelected._id, 'autoBid', auctionSelected?.auctionId, 'details');

    // Rastrear evento de clique no botão de oferta automática
    trackEvent('click_auto_bid', {
      dealershipId: user?.id,
      inspectionId: auctionSelected?._id,
      auctionId: auctionSelected?.auctionId,
      currentOffer: currentOffer,
    });
  }, [selectAuction, auctionSelected, toggleModal, currentAuctionDuration, trackButtonClicked]);

  const handleNegotiateExclusivityModal = useCallback(() => {
    selectAuction(auctionSelected, { remainingTime: currentAuctionDuration * 1000 });
    toggleModal({
      key: AUCTION_BUY_KEY,
      show: true,
      extras: {
        section: 'details',
        showFin: displaySimulationBanner,
        fincreditInfo: fincreditInfo,
        unleashFinFlag: enableSendSimulation,
      },
    });
    trackButtonClicked(
      auctionSelected._id,
      displaySimulationBanner ? 'exclusivityBidFinCredit' : 'exclusivityBid',
      auctionSelected?.auctionId,
      'details',
      new Date().getTime()
    );

    // Rastrear evento de clique no botão de negociação com exclusividade
    trackEvent('click_negotiate_exclusivity', {
      dealershipId: user?.id,
      inspectionId: auctionSelected?._id,
      auctionId: auctionSelected?.auctionId,
      currentOffer: currentOffer,
      buynowPrice: summary?.buynowPrice?.amount,
      showFinancing: displaySimulationBanner,
    });
  }, [selectAuction, auctionSelected, currentAuctionDuration, toggleModal, trackButtonClicked]);

  const handleBuyForModal = useCallback(() => {
    selectAuction(auctionSelected, { remainingTime: currentAuctionDuration * 1000 });
    toggleModal({
      key: AUCTION_BUY_FOR,
      show: true,
      extras: {
        section: 'details',
        showFin: displaySimulationBanner,
        fincreditInfo: fincreditInfo,
        unleashFinFlag: enableSendSimulation,
      },
    });
    trackButtonClicked(
      auctionSelected._id,
      displaySimulationBanner ? 'buyForBidFinCredit' : 'buyForBid',
      auctionSelected?.auctionId,
      'details',
      new Date().getTime()
    );
  }, [selectAuction, auctionSelected, currentAuctionDuration, toggleModal]);

  const handleTiebreakerRulesModal = useCallback(() => {
    toggleModal({
      key: TIEBREAKER_RULES_KEY,
      show: true,
    });
  }, [toggleModal]);

  useEffect(() => {
    page('Página de Detalhes');

    // Inicializar o Amplitude com as informações do usuário
    const amplitude = initAmplitude(user);

    // Rastrear evento de visualização da página de detalhes
    trackEvent('view_details_page', {
      dealershipId: user?.id,
      dealershipEmail: user?.email,
      dealershipName: user?.dealershipName,
      inspectionId: auctionId,
      vehicleDetails: auctionSelected
        ? {
            make: auctionSelected?.summary?.make,
            model: auctionSelected?.summary?.model,
            version: auctionSelected?.summary?.version,
            year: auctionSelected?.summary?.year,
          }
        : {},
    });
  }, []);

  useEffect(
    function() {
      if (auctionId) {
        auctionsActions.setSelectedAuctionId(auctionId);
      } else {
        auctionsActions.setSelectedAuctionId(null);
      }
    },
    [auctionId]
  );

  useEffect(() => {
    listAutoBidVehicles(user.id, user.isNinja());
  }, [user.id]);

  useEffect(() => {
    updateContext({ userId: user?.email });
  }, [user?.email]);

  useEffect(() => {
    if (user.isNinja() || !enabled) {
      listAllAutoBidVehicles();
    }
  }, [user.isNinja, enabled]);

  useEffect(() => {
    if (state !== 'loading' && state === 'default') {
      const storage = JSON.parse(localStorage.getItem(user?.email));

      if (!storage?.find(el => el.id === auctionSelected?.auctionId)) {
        dispatch(createViews(auctionSelected?._id, auctionSelected?.auctionId));
      }

      viewedStorage(user?.email, auctionSelected?.auctionId, auctionSelected?._id, new Date());
      removeViewStorage(user?.email);
    }
  }, [state, user]);

  const getTaxIdNameDiff = () => {
    const oldNickName = auctionTaxProfile;
    const newNickName = newTaxId;
    return [oldNickName, newNickName];
  };

  const changeTaxIdMutation = useMutation(changeTaxIdForAuction, {
    onSuccess: data => {
      const [oldTaxProfile, newTaxProfile] = getTaxIdNameDiff();
      setStatus({
        name: VIEW_STATUS.TAXID_CHANGE_SUCCESS,
        context: { oldTaxId: oldTaxProfile?.nickName, newTaxId: newTaxProfile?.nickName },
      });
      queryClient.invalidateQueries('taxids');
      setChangedTaxId(data);
    },
    onError: error => {
      // console.error('Unexpected error ocurred', error);
      setStatus({
        ...status,
        name: VIEW_STATUS.TAXID_CHANGE_ERROR,
      });
    },
  });

  const openGallery = (index, images) => {
    setGallery({
      show: true,
      slide: index,
      images,
    });
  };

  const goBack = () => history.goBack();

  const { allAuctions: all } = useSelector(state => state.auctions);
  const v = find(all, { _id: auctionId });

  const [recommendeds, setRecommendeds] = useState([]);

  const fetchRecommendeds = async () => {
    const list = [];

    const {
      data: { result },
    } = await authGet(`${AppConstants.API.auctions}/auctions/list-recommended/${auctionId}`);

    result.forEach(({ _id }) => {
      const r = find(all, { _id });
      if (!r) return;
      list.push(r);
    });

    if (!list.length) return;

    list.slice(0, 10);
    list.sort((prev, next) => {
      const prevDate = prev.auction.startTime + prev.auction.initialDuration;
      const nextDate = next.auction.startTime + next.auction.initialDuration;

      return prevDate - nextDate;
    });

    setRecommendeds(list);
  };

  const useRecommendedsLayout = useCallback(() => {
    if (!recommendeds.length) return null;

    return (
      <Recommended.Content>
        <Recommended.Title>Você pode se interessar por</Recommended.Title>
        <NewCarousel auctions={recommendeds} isRecommendedByDetails />
      </Recommended.Content>
    );
  }, [recommendeds]);

  useEffect(() => {
    const possibleRender = enabledRecommended && !!all.length && auctionId;

    if (possibleRender) {
      fetchRecommendeds();
    }
  }, [enabledRecommended, all, auctionId]);

  useEffect(() => {
    if (allAuctions.length > 0) {
      const auction = allAuctions.find(auction => auction._id === auctionId);
      if (auction) {
        selectAuction(auction, { remainingTime: auction?.auction?.remainingTime });
      }
    }
  }, [allAuctions]);

  async function initPage() {
    try {
      setState('loading');
      await checkToken().catch(() => dispatch(deauthenticate(() => history.push('/login'))));

      if (!allAuctions || allAuctions.length < 1) {
        const all = await auctionsActions.fetchAllAuctions();
      }

      const _auction = await auctionsActions.fetchAuction(auctionId);
      setInitialSummarryAmount(
        _auction?.summary?.buyForPrice?.enabled
          ? _auction?.summary?.buyForPrice?.amount
          : _auction?.summary?.buynowPrice?.amount
      );
      if (!_auction) throw Error('Auction not found');
      selectAuction(_auction, { remaningTime: _auction.auction.remainingTime });
      sendEvent('auctionTracker', {
        dealershipId: user?.id,
        dealershipEmail: user?.email,
        dealershipName: user?.dealershipName,
        inspectionId: _auction?._id,
        eventCategory: 'Auctions',
        eventAction: 'Visualizar leilão',
        eventLabel: 'Leilão visualizado',
      });

      setState('default');
      trackGTM(gtmEvents.AUCTION_DETAILS_ACCESS, _auction, eTrackingActions);
    } catch (e) {
      setState('error');
    }
  }
  const fetchData = async () => {
    try {
      const response = await checkFinancingEnabled(user?.email);
      setDisplaySimulationBanner(response);
    } catch (error) {
      // console.error(error);
    }
  };

  const fetchLoadData = async () => {
    try {
      const response = await loadCreditAvaible(user?.id, user?.email, initialSummarryAmount);
      setFincreditInfo(response);
    } catch (error) {
      // console.error(error);
    }
  };

  useEffect(() => {
    updateContext({ userId: user?.email });
  }, [user?.email]);

  useEffect(() => {
    if (enabledSimulationBanner) {
      fetchData();
    }
  }, [enabledSimulationBanner, initialSummarryAmount]);

  useEffect(() => {
    if (enabledSimulationBanner && initialSummarryAmount > 0) {
      fetchLoadData();
    }
  }, [enabledSimulationBanner, initialSummarryAmount]);

  useEffect(() => {
    initPage();
  }, [changedTaxId, auctionId]);

  const handleTopicSummaryViewPhotos = sectionTitle => {
    const titleToGroupMap = {
      Cautelar: 'Laudo Cautelar',
      Pintura: 'Aspecto Visual',
      Pneus: 'Pneus', // Corrigido para usar 'Pneus' em vez de 'Rodas e Pneus'
      'Motor e Câmbio': 'Mecânica',
      'Luz de advertência': 'Mecânica',
      'Opcionais de conforto': 'Funcionalidades',
    };

    const targetGroup = titleToGroupMap[sectionTitle];

    if (targetGroup) {
      setPhotoCategory(1);
      setMainGallery({ show: true, slide: 0 });
      setSelectedGroup(targetGroup);

      setTimeout(() => {
        const gallerySection = document.getElementById('gallery-section');
        if (gallerySection) {
          gallerySection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  // Checa se há conteúdo para o Resumo do carro
  const hasTopicSummaryContent = useMemo(() => {
    const ts = auctionSelected?.summary?.topicSummary;
    if (!ts) return false;

    const { cautelar, pintura, pneus, motorCambio, luzAdvertencia, opcionais } = ts || {};

    const nonEmptyArray = arr => Array.isArray(arr) && arr.length > 0;

    const hasMotorCambio = Array.isArray(motorCambio)
      ? motorCambio.length > 0
      : Boolean(motorCambio);

    const hasOpcionais = Array.isArray(opcionais)
      ? opcionais.some(op => Array.isArray(op?.items) && op.items.length > 0)
      : false;

    const hasCautelar = Boolean(cautelar);

    return (
      hasCautelar ||
      nonEmptyArray(pintura) ||
      nonEmptyArray(pneus) ||
      hasMotorCambio ||
      Boolean(luzAdvertencia) ||
      hasOpcionais
    );
  }, [auctionSelected?.summary?.topicSummary]);

  // Função para verificar se há fotos disponíveis na galeria para uma seção específica
  const hasPhotosInGallery = sectionTitle => {
    if (!summary?.evaluation?.benchmarks?.items) return false;

    const titleToGroupMap = {
      Cautelar: 'Laudo Cautelar',
      Pintura: 'Aspecto Visual',
      Pneus: 'Pneus',
      'Motor e Câmbio': 'Mecânica',
      'Luz de advertência': 'Mecânica',
      'Opcionais de conforto': 'Funcionalidades',
      Rodas: 'Rodas',
      'Aspecto Visual': 'Aspecto Visual',
      'Laudo Cautelar': 'Laudo Cautelar',
      Funcionalidades: 'Funcionalidades',
      Mecânica: 'Mecânica',

      // Adicionando os novos títulos do evaluationV2
      Mecânica: 'Mecânica',
      'Dados do Veículo': 'Dados do Veículo',
      'Motor e Câmbio': 'Mecânica',
      Visual: 'Aspecto Visual',
      Estrutura: 'Laudo Cautelar',
      Funcionalidades: 'Funcionalidades',
      'Rodas e Pneus': 'Pneus',
    };

    const targetGroup = titleToGroupMap[sectionTitle];
    if (!targetGroup) return false;

    // Buscar o grupo correspondente na galeria
    const group = summary.evaluation.benchmarks.items.find(item => item.group === targetGroup);
    if (!group || !group.items) return false;

    // Verificar se há pelo menos uma foto no grupo
    return group.items.some(item => item.img && item.img.src);
  };

  if (state === 'loading') return <Loading centered />;

  if (state !== 'loading' && state !== 'default') {
    return (
      <Box className="absolute-center text-center" width="80%">
        Houve um problema ao tentar carregar este detalhe
        <Button onClick={goBack} mx="auto" mt={2}>
          Voltar
        </Button>
      </Box>
    );
  }
  const participationActive = auctionData?.onGoing && auctionData?.participating;
  const benchmarksFlat = flatten(
    summary?.evaluation?.benchmarks?.items?.map(el => el?.items) || []
  );
  const featuresFlat = flatten(summary?.evaluation?.features?.map(el => el?.items) || []);

  const handleTaxIdChange = ({ taxIdentificationNumber }) => {
    if (!taxIdentificationNumber) return;
    setStatus({ name: VIEW_STATUS.CONFIRM_TAXID_CHANGE, context: { taxIdentificationNumber } });
  };

  const handleTaxIdChangeConfirm = async () => {
    const newTaxIdNumber = status.context?.taxIdentificationNumber;
    setTaxIdDialogChangeSuccess(true);
    setStatus({ ...status, name: VIEW_STATUS.CONFIRM_TAXID_LOADING });
    await changeTaxIdMutation.mutateAsync({
      auctionId: auctionSelected._id,
      taxIdNumber: newTaxIdNumber,
    });
  };

  const handleTaxIdChangeCancel = () => {
    setStatus({ name: VIEW_STATUS.IDLE, context: {} });
  };

  const handleTaxIdChangeSuccessCTA = () => {
    setTaxIdDialogChangeSuccess(false);
    setStatus({ name: VIEW_STATUS < VIEW_STATUS.IDLE, context: {} });
  };

  const handleTaxIdChangeErrorCTA = () => {
    setStatus({ ...status, name: VIEW_STATUS.CONFIRM_TAXID_CHANGE });
  };

  const taxIdOptions = [];
  let selectedTaxId = null;
  let taxids = [];

  const getTaxProfileFromIdNumber = idNumber => {
    const [taxProfile] = taxids.filter(t => t.taxIdentificationNumber === idNumber);
    return taxProfile;
  };

  if (taxIdsQuery.isSuccess) {
    taxids = taxIdsQuery.data?.data?.data || [];
    const approvedTaxIds = taxids.filter(t => t.status === appConstants.TaxIdStatus.APPROVED);

    approvedTaxIds.forEach(
      ({ nickName: label, _id: value, taxIdentificationNumber, type, default: isDefault }) => {
        taxIdOptions.push({
          label,
          value,
          taxIdentificationNumber,
          default: isDefault,
          key: value,
          icon: <TaxProfileIcon profileType={type} />,
        });
      }
    );
  }

  if (auctionData?.taxId) {
    [selectedTaxId] = taxIdOptions.filter(
      taxId => taxId?.taxIdentificationNumber === auctionData?.taxId.taxIdentificationNumber
    );
    auctionTaxProfile = getTaxProfileFromIdNumber(auctionData?.taxId.taxIdentificationNumber);
  } else if (taxIdOptions.length) {
    [selectedTaxId] = taxIdOptions.filter(taxId => taxId.default);
  }

  newTaxId = getTaxProfileFromIdNumber(status.context?.taxIdentificationNumber);

  return (
    <TimingAuctionContextProvider auction={auctionData}>
      <Layout header={false}>
        <Box width="100%" pb={3}>
          <SealsContainer auction={updatedAuction} isDetailsPage={true} />
          <BackButton onClick={goBack}>
            <Button.Icon>
              <MdKeyboardBackspace size={14} />
            </Button.Icon>{' '}
            Voltar
          </BackButton>
          {updatedAuction?.summary && getCarouselPhotos().length > 0 && (
            <CarouselPhoto
              photos={getCarouselPhotos()}
              bigArrows
              sm={1}
              md={2}
              lg={3}
              detailVehicle
              height={{ sm: 240, md: 361 }}
              onClickSlide={i => {
                setMainGallery({ show: true, slide: i });
              }}
              trackCarousel={() =>
                trackCarouselInteraction(
                  auctionSelected?._id,
                  auctionSelected?.auctionId,
                  'details'
                )
              }
            >
              <Flex css={{ position: 'absolute', bottom: '14px', left: '32px' }}>
                {updatedAuction?.summary?.hasD2D && (
                  <Tag.Container bg="#171C24" style={{ marginRight: '6px', padding: '6px 12px' }}>
                    <Tag.Text color="#FFF6A7" style={{ fontSize: '0.75rem' }}>
                      Avaliado por parceiros
                    </Tag.Text>
                  </Tag.Container>
                )}

                {!updatedAuction?.summary?.hasD2D &&
                  (enabledMoreViewedTag && auctionData?.numberOfDealersParticipating < 4 ? (
                    <Tag.Container bg="#fff">
                      <Tag.Icon viewed color="#2274a5" />
                      <Tag.Text color="#2274a5">Mais visualizado</Tag.Text>
                    </Tag.Container>
                  ) : (
                    <Tag.Container>
                      <Tag.Icon />
                      <Tag.Text>
                        <span style={{ fontWeight: 'bold' }}>Concorrido</span>:{' '}
                        {auctionData?.numberOfDealersParticipating} participando
                      </Tag.Text>
                    </Tag.Container>
                  ))}
                {!updatedAuction?.summary?.hasD2D && (
                  <FavoriteDiv>
                    <Tag.Container>
                      <Tag.Icon favorite color="#FF7B7B" />
                      <Tag.Text>Mais favoritado</Tag.Text>
                    </Tag.Container>
                  </FavoriteDiv>
                )}
              </Flex>
            </CarouselPhoto>
          )}

          <VehicleInfoBanner>
            <VehicleInformationsContainer>
              <VehicleNameAndInfos>
                {summary?.make} {summary?.model} {summary?.version}
                {size >= 1025 && displaySimulationBanner && fincreditInfo && <TagFincredit />}
              </VehicleNameAndInfos>

              {size >= 1025 && !user.isNinja() && participationActive && (
                <Select
                  options={taxIdOptions}
                  selectedItem={selectedTaxId}
                  onChange={handleTaxIdChange}
                  variant="primary"
                  placeholder="Selecione um perfil"
                  listProps={{
                    style: {
                      width: '150%',
                    },
                  }}
                  hideTick
                />
              )}
            </VehicleInformationsContainer>

            <VehicleChronometerAndLastOffer>
              {size < 1025 && !user.isNinja() && participationActive && (
                <Select
                  options={taxIdOptions}
                  selectedItem={selectedTaxId}
                  onChange={handleTaxIdChange}
                  variant="primary"
                  placeholder="Selecione um perfil"
                  listProps={{
                    style: {
                      width: '150%',
                    },
                  }}
                  hideTick
                />
              )}

              <ProgressTimer
                auction={auctionSelected}
                labelProps={{
                  color: '#ffffff',
                  fontSize: 1,
                  width: 'auto',
                }}
                detailVehicle
                timeProps={{ color: '#ffffff', fontSize: 3 }}
                participationActive={participationActive}
              />

              {size >= 1025 && (
                <>
                  <VehicleLastOfferLabel>Lance atual do leilão:</VehicleLastOfferLabel>
                  <VehicleLastOfferAndIsWinningStatus
                    isParticipating={!user.isNinja() && participationActive}
                  >
                    <VehicleLastOfferValue>R$ {currentOfferLabel}</VehicleLastOfferValue>
                    {enabledPrices && (
                      <>
                        <PercentageTag
                          price={v?.summary?.marketPrice}
                          currentOffer={currentOffer}
                          isDetails
                        />
                        <PercentageTag
                          price={summary?.webPrice}
                          currentOffer={currentOffer}
                          web
                          isDetails
                        />
                      </>
                    )}
                  </VehicleLastOfferAndIsWinningStatus>
                  {!user.isNinja() && participationActive && (
                    <VehicleIsWinningLabel bg={auctionData?.winning ? '#05762d' : '#c50000'}>
                      {auctionData?.winning ? 'Ganhando' : 'Perdendo'}
                    </VehicleIsWinningLabel>
                  )}

                  {!user.isNinja() &&
                  auctionData?.winning &&
                  !isActiveAutoBid &&
                  !v?.summary?.hasD2D ? (
                    <Temperature.Basic
                      auction={v}
                      currentValue={auctionData?.winningBid?.amount}
                      isDetails
                    />
                  ) : null}

                  {tieWithEdits && enabled ? (
                    <FeedbackAutoBidContainer>
                      <GoAlert
                        size={40}
                        fill="#C50000"
                        style={{
                          alignSelf: 'flex-start',
                          marginRight: '.313rem',
                          height: '18px',
                        }}
                      />
                      <FeedbackAutoBidLabel>
                        <strong>
                          Outro lojista definiu primeiro o limite de {maximumAutoBidBudget}. Insira
                          um limite maior para continuar na disputa.
                        </strong>{' '}
                        <AutoBidRules onClick={handleTiebreakerRulesModal}>
                          Consulte a regra de desempate.
                        </AutoBidRules>
                      </FeedbackAutoBidLabel>
                    </FeedbackAutoBidContainer>
                  ) : null}

                  {tieWithoutEdits && enabled ? (
                    <FeedbackAutoBidContainer>
                      <GoAlert
                        size={40}
                        fill="#C50000"
                        style={{
                          alignSelf: 'flex-start',
                          marginRight: '.313rem',
                          height: '18px',
                        }}
                      />
                      <FeedbackAutoBidLabel>
                        <strong>
                          Outro lojista definiu primeiro o limite de {maximumAutoBidBudget}.
                        </strong>{' '}
                        Edições encerradas, continue na disputa através da oferta avulsa
                        {auctionSelected?.summary.buynowPrice.enabled &&
                          ' ou negocie com exclusividade'}
                        .
                      </FeedbackAutoBidLabel>
                    </FeedbackAutoBidContainer>
                  ) : null}

                  {losingInBothWays && !tieWithEdits && enabled ? (
                    <FeedbackAutoBidContainer>
                      <GoAlert
                        size={40}
                        fill="#C50000"
                        style={{
                          alignSelf: 'flex-start',
                          marginRight: '.313rem',
                          height: '18px',
                        }}
                      />
                      <FeedbackAutoBidLabel>
                        <strong>
                          O lance de {maximumAutoBidBudget} foi superado por outro lojista. Insira
                          um valor maior de limite para voltar a disputar o leilão.
                        </strong>
                      </FeedbackAutoBidLabel>
                    </FeedbackAutoBidContainer>
                  ) : null}

                  {losingInBothWaysWithoutEdits && !tieWithoutEdits && enabled ? (
                    <FeedbackAutoBidContainer>
                      <GoAlert
                        size={40}
                        fill="#C50000"
                        style={{
                          alignSelf: 'flex-start',
                          marginRight: '.313rem',
                          height: '18px',
                        }}
                      />
                      <FeedbackAutoBidLabel>
                        <strong>
                          O lance de {maximumAutoBidBudget} foi superado por outro lojista.
                        </strong>{' '}
                        Edições encerradas, continue na disputa através da oferta avulsa
                        {auctionSelected?.summary.buynowPrice.enabled &&
                          ' ou negocie com exclusividade'}
                        .
                      </FeedbackAutoBidLabel>
                    </FeedbackAutoBidContainer>
                  ) : null}

                  {noEditsInBothWays && enabled ? (
                    <FeedbackAutoBidContainer>
                      <AlertIconImg
                        src={AlertIcon}
                        alt="Círculo preenchido de cinza com um ponto de exclamação no centro."
                      />
                      <FeedbackAutoBidLabel>
                        Você não pode mais alterar o <strong>lance máximo</strong> porque atingiu o
                        número máximo de edições.
                      </FeedbackAutoBidLabel>
                    </FeedbackAutoBidContainer>
                  ) : null}

                  {noEditsAndDesconfigured && enabled ? (
                    <FeedbackAutoBidContainer style={{ marginTop: '16px' }}>
                      <AlertIconImg
                        src={AlertIcon}
                        alt="Círculo preenchido de cinza com um ponto de exclamação no centro."
                      />
                      <FeedbackAutoBidLabel>
                        Você não pode mais fazer a <strong>oferta automática</strong> porque atingiu
                        o número máximo de edições.
                      </FeedbackAutoBidLabel>
                    </FeedbackAutoBidContainer>
                  ) : null}

                  {automaticToSingleOfferLosing ? (
                    <FeedbackAutoBidContainer>
                      <GoAlert
                        size={110}
                        fill="#C50000"
                        style={{
                          alignSelf: 'flex-start',
                          marginRight: '.313rem',
                          height: '18px',
                        }}
                      />
                      <FeedbackAutoBidLabel>
                        <strong>
                          O seu lance foi superado rapidamente porque outro lojista definiu um valor
                          de oferta previamente que cobriu o seu lance de modo automático.
                        </strong>{' '}
                        Essa é uma nova funcionalidade, ainda está em teste e por isso não está
                        habilitada para você. Caso também queira utilizar esta funcionalidade, entre
                        em contato com o atendimento.
                      </FeedbackAutoBidLabel>
                    </FeedbackAutoBidContainer>
                  ) : null}
                </>
              )}
            </VehicleChronometerAndLastOffer>

            <VehicleLastOfferResponsiveContainer participating={participationActive}>
              {displaySimulationBanner && fincreditInfo && <TagFincredit />}
              <VehicleLastOfferLabel>Lance atual do leilão:</VehicleLastOfferLabel>
              <VehicleLastOfferAndIsWinningStatus
                isParticipating={!user.isNinja() && participationActive}
              >
                <VehicleLastOfferValue>R$ {currentOfferLabel}</VehicleLastOfferValue>
                {enabledPrices && (
                  <>
                    <PercentageTag
                      price={v?.summary?.marketPrice}
                      currentOffer={currentOffer}
                      isDetails
                      marketPrice={updatedAuction?.summary?.marketPrice}
                    />
                    <PercentageTag
                      price={summary?.webPrice}
                      currentOffer={currentOffer}
                      web
                      isDetails
                      marketPrice={updatedAuction?.summary?.marketPrice}
                    />
                  </>
                )}
              </VehicleLastOfferAndIsWinningStatus>
              {whitelistDebug && (
                <div
                  style={{
                    position: 'fixed',
                    top: 20,
                    right: 20,
                    width: 'min(600px, 90vw)',
                    height: '70vh',
                    background: '#ffffff',
                    color: '#000000',
                    border: '3px solid #ff006e',
                    borderRadius: 10,
                    boxShadow: '0 8px 24px rgba(0,0,0,0.3)',
                    zIndex: 9999,
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <div
                    style={{
                      padding: '12px 16px',
                      background: '#ff006e',
                      color: '#ffffff',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      fontWeight: 800,
                      letterSpacing: 0.5,
                    }}
                  >
                    <span>DEBUG WHITELIST (carwhitelists)</span>
                    <button
                      onClick={() => setWhitelistDebug(null)}
                      style={{
                        background: 'transparent',
                        border: 'none',
                        color: '#ffffff',
                        fontSize: 18,
                        cursor: 'pointer',
                      }}
                      aria-label="Fechar debug whitelist"
                      title="Fechar"
                    >
                      ✕
                    </button>
                  </div>
                  <div
                    style={{
                      padding: 16,
                      overflow: 'auto',
                      fontFamily: 'monospace',
                      fontSize: 14,
                      lineHeight: 1.5,
                    }}
                  >
                    <div style={{ marginBottom: 8 }}>
                      <strong>Slug base</strong>:{' '}
                      {`${updatedAuction?.summary?.make || v?.summary?.make || ''} ${updatedAuction
                        ?.summary?.model ||
                        v?.summary?.model ||
                        ''} ${updatedAuction?.summary?.year || v?.summary?.year || ''}`}
                    </div>
                    <pre style={{ margin: 0, whiteSpace: 'pre-wrap' }}>
                      {JSON.stringify(whitelistDebug, null, 2)}
                    </pre>
                  </div>
                </div>
              )}
              {!user.isNinja() && participationActive && (
                <VehicleIsWinningLabel bg={auctionData?.winning ? '#438a4c' : '#fcab10'}>
                  {auctionData?.winning ? 'Ganhando' : 'Perdendo'}
                </VehicleIsWinningLabel>
              )}
              {!user.isNinja() &&
              auctionData?.winning &&
              !isActiveAutoBid &&
              !v?.summary?.hasD2D ? (
                <>
                  <Temperature.Basic
                    auction={v}
                    currentValue={auctionData?.winningBid?.amount}
                    isDetails
                  />
                  <hr
                    style={{ width: '100%', margin: '18px 0 24px', backgroundColor: '#d6d6d6' }}
                  />
                </>
              ) : null}

              {tieWithEdits && enabled ? (
                <FeedbackAutoBidContainer>
                  <GoAlert
                    size={40}
                    fill="#C50000"
                    style={{
                      alignSelf: 'flex-start',
                      marginRight: '.313rem',
                      height: '18px',
                    }}
                  />
                  <FeedbackAutoBidLabel>
                    <strong>
                      Outro lojista definiu primeiro o limite de {maximumAutoBidBudget}. Insira um
                      limite maior para continuar na disputa.
                    </strong>{' '}
                    <AutoBidRules onClick={handleTiebreakerRulesModal}>
                      Consulte a regra de desempate.
                    </AutoBidRules>
                  </FeedbackAutoBidLabel>
                </FeedbackAutoBidContainer>
              ) : null}

              {tieWithoutEdits && enabled ? (
                <FeedbackAutoBidContainer>
                  <GoAlert
                    size={40}
                    fill="#C50000"
                    style={{
                      alignSelf: 'flex-start',
                      marginRight: '.313rem',
                      height: '18px',
                    }}
                  />
                  <FeedbackAutoBidLabel>
                    <strong>
                      Outro lojista definiu primeiro o limite de {maximumAutoBidBudget}.
                    </strong>{' '}
                    Edições encerradas, continue na disputa através da oferta avulsa
                    {auctionSelected?.summary.buynowPrice.enabled &&
                      ' ou negocie com exclusividade'}
                    .
                  </FeedbackAutoBidLabel>
                </FeedbackAutoBidContainer>
              ) : null}

              {losingInBothWays && !tieWithEdits && enabled ? (
                <FeedbackAutoBidContainer>
                  <GoAlert
                    size={40}
                    fill="#C50000"
                    style={{
                      alignSelf: 'flex-start',
                      marginRight: '.313rem',
                      height: '18px',
                    }}
                  />
                  <FeedbackAutoBidLabel>
                    <strong>
                      O lance de {maximumAutoBidBudget} foi superado por outro lojista. Insira um
                      valor maior de limite para voltar a disputar o leilão.
                    </strong>
                  </FeedbackAutoBidLabel>
                </FeedbackAutoBidContainer>
              ) : null}

              {losingInBothWaysWithoutEdits && !tieWithoutEdits && enabled ? (
                <FeedbackAutoBidContainer>
                  <GoAlert
                    size={40}
                    fill="#C50000"
                    style={{
                      alignSelf: 'flex-start',
                      marginRight: '.313rem',
                      height: '18px',
                    }}
                  />
                  <FeedbackAutoBidLabel>
                    <strong>
                      O lance de {maximumAutoBidBudget} foi superado por outro lojista.
                    </strong>{' '}
                    Edições encerradas, continue na disputa através da oferta avulsa
                    {auctionSelected?.summary.buynowPrice.enabled &&
                      ' ou negocie com exclusividade'}
                    .
                  </FeedbackAutoBidLabel>
                </FeedbackAutoBidContainer>
              ) : null}

              {automaticToSingleOfferLosing ? (
                <FeedbackAutoBidContainer>
                  <GoAlert
                    size={110}
                    fill="#C50000"
                    style={{
                      alignSelf: 'flex-start',
                      marginRight: '.313rem',
                      height: '18px',
                    }}
                  />
                  <FeedbackAutoBidLabel>
                    <strong>
                      O seu lance foi superado rapidamente porque outro lojista definiu um valor de
                      oferta previamente que cobriu o seu lance de modo automático.
                    </strong>{' '}
                    Essa é uma nova funcionalidade, ainda está em teste e por isso não está
                    habilitada para você. Caso também queira utilizar esta funcionalidade, entre em
                    contato com o atendimento.
                  </FeedbackAutoBidLabel>
                </FeedbackAutoBidContainer>
              ) : null}

              {noEditsInBothWays && enabled ? (
                <FeedbackAutoBidContainer>
                  <AlertIconImg
                    src={AlertIcon}
                    alt="Círculo preenchido de cinza com um ponto de exclamação no centro."
                  />
                  <FeedbackAutoBidLabel>
                    Você não pode mais alterar o <strong>lance máximo</strong> porque atingiu o
                    número máximo de edições.
                  </FeedbackAutoBidLabel>
                </FeedbackAutoBidContainer>
              ) : null}

              {noEditsAndDesconfigured && enabled ? (
                <FeedbackAutoBidContainer style={{ marginTop: '16px' }}>
                  <AlertIconImg
                    src={AlertIcon}
                    alt="Círculo preenchido de cinza com um ponto de exclamação no centro."
                  />
                  <FeedbackAutoBidLabel>
                    Você não pode mais fazer a <strong>oferta automática</strong> porque atingiu o
                    número máximo de edições.
                  </FeedbackAutoBidLabel>
                </FeedbackAutoBidContainer>
              ) : null}
            </VehicleLastOfferResponsiveContainer>

            <VehicleActions specificStyle={!summary.buynowPrice.enabled}>
              <React.Fragment>
                {isActiveAutoBid &&
                !tieWithoutEdits &&
                !losingInBothWaysWithoutEdits &&
                enabled &&
                !user.isNinja() ? (
                  <AutoBidAction detailsVehicle auction={v} />
                ) : (
                  <>
                    {user.isNinja() ||
                    vehicleWithoutUpdateLimit ||
                    currentAutoBidConfigured?.updateLimit === 2 ||
                    !enabled ? (
                      <Column>
                        <NewButton hover="#4ab971" onClick={handleSingleOfferModal}>
                          Oferta avulsa
                        </NewButton>

                        {!summary.buyForPrice.enabled && summary.buynowPrice.enabled && (
                          <div>
                            <TextEndingdiv>
                              <TextEnding>Negociar com exclusividade:</TextEnding>
                            </TextEndingdiv>
                            <NewButton
                              fontWeight={400}
                              bg="#ff4c00"
                              hover="#ff7941"
                              onClick={handleNegotiateExclusivityModal}
                            >
                              {displaySimulationBanner && fincreditInfo?.entryAmount ? (
                                <>
                                  Negocie por R$ {formatPrice(summary?.buynowPrice?.amount)} à vista
                                  <br />
                                  <strong>
                                    {' '}
                                    ou entrada de{' '}
                                    {fincreditInfo?.entryAmount.toLocaleString('pt-BR', {
                                      style: 'currency',
                                      currency: 'BRL',
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                  </strong>
                                </>
                              ) : (
                                <>
                                  Negocie a partir de{' '}
                                  <strong>R$ {formatPrice(summary?.buynowPrice?.amount)}</strong>
                                </>
                              )}
                            </NewButton>
                          </div>
                        )}

                        {summary.buyForPrice.enabled && (
                          <div>
                            <TextEndingdiv>
                              <TextEnding>Compra garantida:</TextEnding>
                            </TextEndingdiv>
                            <NewButton
                              onClick={handleBuyForModal}
                              fontWeight={400}
                              color="#000"
                              bg="#f2c94c"
                            >
                              {displaySimulationBanner && fincreditInfo?.entryAmount ? (
                                <>
                                  Compre por R$ {formatPrice(summary.buyForPrice.amount)} à vista
                                  <br />
                                  <strong>
                                    {' '}
                                    ou entrada de{' '}
                                    {fincreditInfo?.entryAmount.toLocaleString('pt-BR', {
                                      style: 'currency',
                                      currency: 'BRL',
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                  </strong>
                                </>
                              ) : (
                                <>
                                  Compra garantida por{' '}
                                  <strong>R$ {formatPrice(summary.buyForPrice.amount)}</strong>
                                </>
                              )}
                            </NewButton>
                          </div>
                        )}
                      </Column>
                    ) : (
                      <Column>
                        <Row>
                          <NewButton hover="#4ab971" onClick={handleSingleOfferModal}>
                            Oferta avulsa
                          </NewButton>
                          <NewButton hover="#4ab971" onClick={handleAutomaticOfferModal}>
                            Automática
                          </NewButton>
                        </Row>

                        {!summary.buyForPrice.enabled && summary.buynowPrice.enabled && (
                          <div>
                            <TextEndingdiv>
                              <TextEnding>Negociar com exclusividade:</TextEnding>
                            </TextEndingdiv>
                            <NewButton
                              fontWeight={400}
                              bg="#ff4c00"
                              hover="#ff7941"
                              onClick={handleNegotiateExclusivityModal}
                            >
                              {displaySimulationBanner && fincreditInfo?.entryAmount ? (
                                <>
                                  Negocie por R$ {formatPrice(summary?.buynowPrice?.amount)} à vista
                                  <br />
                                  <strong>
                                    {' '}
                                    ou entrada de{' '}
                                    {fincreditInfo?.entryAmount.toLocaleString('pt-BR', {
                                      style: 'currency',
                                      currency: 'BRL',
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                  </strong>
                                </>
                              ) : (
                                <>
                                  Negocie a partir de{' '}
                                  <strong>R$ {formatPrice(summary?.buynowPrice?.amount)}</strong>
                                </>
                              )}
                            </NewButton>
                          </div>
                        )}

                        {summary.buyForPrice.enabled && (
                          <div>
                            <TextEndingdiv>
                              <TextEnding>Compra garantida:</TextEnding>
                            </TextEndingdiv>
                            <NewButton
                              onClick={handleBuyForModal}
                              fontWeight={400}
                              color="#000"
                              bg="#f2c94c"
                            >
                              {displaySimulationBanner && fincreditInfo?.entryAmount ? (
                                <>
                                  Compre por R$ {formatPrice(summary.buyForPrice.amount)} à vista
                                  <br />
                                  <strong>
                                    {' '}
                                    ou entrada de{' '}
                                    {fincreditInfo?.entryAmount.toLocaleString('pt-BR', {
                                      style: 'currency',
                                      currency: 'BRL',
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                  </strong>
                                </>
                              ) : (
                                <>
                                  Compra garantida por{' '}
                                  <strong>R$ {formatPrice(summary.buyForPrice.amount)}</strong>
                                </>
                              )}
                            </NewButton>
                          </div>
                        )}
                      </Column>
                    )}
                  </>
                )}
              </React.Fragment>
            </VehicleActions>
          </VehicleInfoBanner>

          <Content>
            {/* D2D */}
            {updatedAuction?.summary?.hasD2D && (
              <SummaryD2D
                auction={updatedAuction?.auction}
                summary={updatedAuction?.summary}
                updatedAuction={updatedAuction}
                evaluationComment={summary?.evaluation?.summary}
              />
            )}
            {/* CORE */}
            {!updatedAuction?.summary?.hasD2D && summary && Object.keys(summary).length > 0 && (
              <Summary
                auction={auctionData}
                summary={summary}
                marketPrice={v?.summary?.marketPrice}
                updatedAuction={updatedAuction}
                evaluationComment={summary?.evaluation?.summary}
              />
            )}
            {updatedAuction?.summary?.documentResearch?.historics &&
              Object.keys(updatedAuction?.summary?.documentResearch?.historics).length > 0 && (
                <DocumentResearch
                  showHistoric
                  research={updatedAuction?.summary?.documentResearch}
                />
              )}

            {/* TopicSummary - Adicionado aqui */}
            {hasTopicSummaryContent && !updatedAuction?.summary?.hasD2D && (
              <TopicSummary
                topicSummary={auctionSelected.summary.topicSummary}
                onViewPhotos={handleTopicSummaryViewPhotos}
                hasPhotosInGallery={hasPhotosInGallery}
              />
            )}

            {updatedAuction?.documentResearch?.historics &&
              Object.keys(updatedAuction?.documentResearch?.historics).length > 0 && (
                <DocumentResearch showHistoric research={updatedAuction} />
              )}
            {/* <MaximumQuality /> */}

            {/* INFORMAÇÕES DO VEÍCULO */}
            {updatedAuction?.summary?.hasD2D ? (
              <>
                <VehicleD2DVideos updatedAuction={updatedAuction} />
                <VehicleConditionsD2D updatedAuction={updatedAuction} />
              </>
            ) : (
              <div className="evaluation-section" id="gallery-section">
                {enabledNewInspectionPoints ? (
                  <>
                    {summary?.evaluationV2 ? (
                      <NewSection.Container
                        title="Avaliação completa"
                        icon={<img src={Clipboard} />}
                        hideLine
                        useNewLayout
                      >
                        <VehicleVideos auction={auctionSelected} />
                        {transformToSections(summary?.evaluationV2)?.map(({ title, data }) => {
                          // Mapeamento de títulos para grupos da galeria
                          const titleToGroupMap = {
                            Mecânica: 'Mecânica',
                            'Dados do veículo': 'Dados do veículo',
                            'Motor e Câmbio': 'Mecânica',
                            Visual: 'Aspecto Visual',
                            Estrutura: 'Laudo Cautelar',
                            Funcionalidades: 'Funcionalidades',
                            'Rodas e Pneus': 'Pneus',
                            Pneus: 'Pneus',
                            Rodas: 'Rodas',
                          };

                          const targetGroup = titleToGroupMap[title] || title;
                          const hasPhotos = hasPhotosInGallery(title);

                          return (
                            <NewSection.Content
                              key={title}
                              title={title}
                              items={data}
                              onGallery={
                                hasPhotos
                                  ? () => {
                                      setPhotoCategory(1);
                                      setMainGallery({ show: true, slide: 0 });
                                      setSelectedGroup(targetGroup);
                                    }
                                  : undefined
                              }                              collapsed
                              useNewSort
                              auction={auctionData}
                            />
                          );
                        })}
                        <NewSection.Container hideIcon hideLine>
                          {summary?.evaluation?.features?.map(({ group, items }) => (
                            <NewSection.Content
                              key={group}
                              title={group}
                              items={items}
                              isOptional
                              onGallery={openGallery}
                              collapsed
                              useNewLayout
                            />
                          ))}
                        </NewSection.Container>
                      </NewSection.Container>
                    ) : (
                      <>
                        <VehicleVideos auction={auctionSelected} />
                        <NewSection.Container title="Pontos de atenção">
                          {summary?.evaluation?.benchmarks?.rejected?.map(({ group, items }) => {
                            const hasPhotos = hasPhotosInGallery(group);
                            return (
                              <NewSection.Content
                                key={group}
                                title={group}
                                items={items}
                                onGallery={
                                  hasPhotos
                                    ? () => {
                                        setPhotoCategory(1);
                                        setMainGallery({ show: true, slide: 0 });
                                        setSelectedGroup(group);
                                      }
                                    : undefined
                                }                                collapsed
                              />
                            );
                          })}
                        </NewSection.Container>
                        <NewSection.Container title="Pontos aprovados" color="#22AA52">
                          {summary?.evaluation?.benchmarks?.accepted?.map(({ group, items }) => {
                            const hasPhotos = hasPhotosInGallery(group);
                            return (
                              <NewSection.Content
                                key={group}
                                title={group}
                                items={items}
                                isOptional
                                onGallery={
                                  hasPhotos
                                    ? () => {
                                        setPhotoCategory(1);
                                        setMainGallery({ show: true, slide: 0 });
                                        setSelectedGroup(group);
                                      }
                                    : undefined
                                }                                collapsed
                              />
                            );
                          })}
                        </NewSection.Container>
                        <NewSection.Container title="Opcionais" color="#056A8B" hideLine>
                          {summary?.evaluation?.features?.map(({ group, items }) => (
                            <NewSection.Content
                              key={group}
                              title={group}
                              items={items}
                              isOptional
                              onGallery={openGallery}
                              collapsed
                            />
                          ))}
                        </NewSection.Container>
                      </>
                    )}

                    <AvaliatorContent>
                      <NewAppraiser
                        name={summary?.mechanicName}
                        picture={summary?.mechanicPicture}
                        useNewLayout={!!summary?.evaluationV2}
                      />
                    </AvaliatorContent>
                  </>
                ) : (
                  <>
                    <Section
                      title="Resumo do Veículo"
                      counter={summary.evaluation.highlights.length}
                      items={summary.evaluation.highlights}
                      onOpenFullscreen={openGallery}
                      passed
                    />
                    <Tabs>
                      <DetailsTab />
                      <Tabs.TabPanel
                        tabId="rejected"
                        tabTitle="Pontos de atenção"
                        tabProps={{
                          color: 'alerts.Ferrari',
                          counter: benchmarksFlat?.filter(e => !e.passed).length,
                        }}
                      >
                        {summary.evaluation.benchmarks.rejected.map(({ group, items }) => (
                          <Section
                            title={group}
                            counter={items.length}
                            items={items}
                            onOpenFullscreen={openGallery}
                            key={group}
                          />
                        ))}
                      </Tabs.TabPanel>
                      <Tabs.TabPanel
                        tabId="accepted"
                        tabTitle="Pontos aprovados"
                        tabProps={{
                          color: 'secondaries.Uno',
                          counter: benchmarksFlat?.filter(e => e.passed).length,
                        }}
                        passed
                      >
                        {summary.evaluation.benchmarks.accepted.map(({ group, items }) => (
                          <Section
                            title={group}
                            counter={items.length}
                            items={items}
                            onOpenFullscreen={openGallery}
                            passed
                            key={group}
                          />
                        ))}
                      </Tabs.TabPanel>
                      <Tabs.TabPanel
                        tabId="features"
                        tabTitle="Opcionais do carro"
                        tabProps={{
                          color: 'secondaries.Uno',
                          counter: featuresFlat?.length,
                        }}
                        passed
                      >
                        {summary.evaluation.features.map(({ group, items }) => (
                          <Section
                            title={group}
                            counter={items.length}
                            items={items}
                            onOpenFullscreen={openGallery}
                            passed
                            key={group}
                          />
                        ))}
                      </Tabs.TabPanel>
                    </Tabs>

                    <Appraiser
                      appraiser={{
                        mechanicName: summary.mechanicName,
                        mechanicPicture: summary.mechanicPicture,
                      }}
                    />
                  </>
                )}

                {useRecommendedsLayout()}

                {gallery.show && (
                  <PhotoGallery
                    images={gallery.images}
                    slideIndex={gallery.slide}
                    onDismiss={() => {
                      setGallery({ ...gallery, show: false });
                    }}
                  />
                )}

                {!updatedAuction?.summary?.hasD2D && mainGallery.show && (
                  <PhotoGallery
                    photos={summary?.photos?.filter(url => url.endsWith('.jpg') ||
                    url.endsWith('.jpeg') ||
                    url.endsWith('.png') ||
                    url.endsWith('.webp'))}
                    categoryPhotos={summary?.evaluation?.benchmarks}
                    categorySelected={photoCategory}
                    nextCategoryGalery={true}
                    slideIndex={mainGallery.slide}
                    onDismiss={() => {
                      setMainGallery({ ...mainGallery, show: false });
                    }}
                    selectedGroup={selectedGroup}
                    Header={
                      <PhotoCategoryButtonContainer>
                        {photosCategory.map((photo, index) => (
                          <PhotoCategoryButton
                            isSelected={photoCategory === index}
                            key={index}
                            onClick={() => {
                              setPhotoCategory(index);
                              setMainGallery({ ...mainGallery, slide: 0 });
                            }}
                          >
                            <MainPhotoText isSelected={photoCategory === index}>
                              {photo.label}
                            </MainPhotoText>
                          </PhotoCategoryButton>
                        ))}
                      </PhotoCategoryButtonContainer>
                    }
                    Footer={
                      <ProgressTimer
                        auction={auctionSelected}
                        labelProps={{
                          color: '#ffffff',
                          fontSize: 0,
                          width: 'auto',
                        }}
                        timeProps={{ color: '#ffffff', fontSize: 2 }}
                        progressBarProps={{
                          style: {
                            borderRadius: 0,
                          },
                        }}
                        reverse
                      />
                    }
                    openCarousel={mainGallery.show}
                  />
                )}
              </div>
            )}

            {updatedAuction?.summary?.hasD2D && (
              <>
                <DocumentedModificationD2D updatedAuction={updatedAuction} />
                <ReturnPolicyD2D updatedAuction={updatedAuction} />
              </>
            )}
          </Content>
        </Box>
        <Modal
          show={[
            VIEW_STATUS.TAXID_CHANGE_SUCCESS,
            VIEW_STATUS.TAXID_CHANGE_ERROR,
            VIEW_STATUS.CONFIRM_TAXID_CHANGE,
            VIEW_STATUS.CONFIRM_TAXID_LOADING,
          ].includes(status.name)}
          toggle={handleTaxIdChangeCancel}
          hideCloseBtn
          style={{
            content: {
              position: 'absolute',
              background: 'transparent',
              top: '0',
              left: '0',
              bottom: '0',
              right: '0',
              padding: 0,
              zIndex: 99992,
              border: 0,
            },
            overlay: {
              background: 'rgba(0, 0, 0, 0.95)',
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              zIndex: 99991,
            },
          }}
        >
          {auctionTaxProfile && newTaxId && status.name === VIEW_STATUS.CONFIRM_TAXID_CHANGE && (
            <ChangeTaxIdDialog
              header="Você gostaria de alterar as informaçōes para emissão de documentos?"
              onCTAClick={handleTaxIdChangeConfirm}
              onSecondaryBtnClick={handleTaxIdChangeCancel}
              oldTaxId={auctionTaxProfile}
              newTaxId={newTaxId}
            />
          )}
          {taxIdDialogChangeSuccess && status.name === VIEW_STATUS.TAXID_CHANGE_SUCCESS && (
            <Dialog
              header="Alteração realizada com sucesso!"
              onCTAClick={handleTaxIdChangeSuccessCTA}
            >
              <p>
                Você acabou de atualizar as informações de emissão do DUT e da nota fiscal do{' '}
                {status.context?.oldTaxId} para {status.context?.newTaxId}
              </p>
            </Dialog>
          )}
          {status.name === VIEW_STATUS.TAXID_CHANGE_ERROR && (
            <Dialog
              header="Problema com a alteração"
              onCTAClick={handleTaxIdChangeErrorCTA}
              primaryBtnLabel="Tentar novamente"
              variant="error"
              primaryBtnVariant="error"
            >
              <p>
                Tivemos um problema com a tentativa de alteração de dados para emissão dos
                documentos. Por favor, tente novamente
              </p>
            </Dialog>
          )}
        </Modal>
        {updatedAuction?.summary?.hasD2D && mainGallery.show && (
          <>
            <CloseButton
              onClick={() => setMainGallery(oldValue => ({ ...oldValue, show: false }))}
              style={{
                position: 'absolute',
                top: 0,
                right: -20,
                zIndex: 99999,
              }}
            />
            <Modal
              show={mainGallery.show}
              style={{
                content: {
                  position: 'absolute',
                  background: 'transparent',
                  top: '100px',
                  padding: 0,
                  zIndex: 99992,
                  border: 0,
                  width: '80vw',
                  maxWidth: '700px',
                  margin: '0 auto',
                },
                overlay: {
                  background: 'rgba(0, 0, 0, 0.95)',
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  zIndex: 99991,
                },
              }}
            >
              <CarouselPhoto
                photos={getD2DPhotos(updatedAuction?.summary?.additionalInfo) || []}
                bigArrows
                sm={1}
                md={1}
                lg={1}
                openCarousel={mainGallery.show}
                active={mainGallery.slide}
                detailVehicle
                height={{ sm: '35.3vh', md: '50.5vh', lg: '51.5vh' }}
                onChange={index => {
                  setMainGallery(oldValue => ({ ...oldValue, slide: index }));
                }}
              />
              <TumbContainer>
                <Tumbnail
                  value={mainGallery.slide}
                  onChange={index => {
                    setMainGallery(oldValue => ({ ...oldValue, slide: index }));
                  }}
                  slidesPerPage={8}
                  breakpoints={{
                    780: {
                      slidesPerPage: 5,
                    },
                    500: {
                      slidesPerPage: 3,
                    },
                  }}
                >
                  {(getD2DPhotos(updatedAuction?.summary?.additionalInfo) || []).map((photo, i) => (
                    <img
                      src={photo}
                      alt={`Imagem ${i + 1}`}
                      key={`${photo}-${Math.random()}`}
                      className={mainGallery.slide === i ? 'active' : ''}
                      onClick={() => {
                        setMainGallery({ show: mainGallery.show, slide: i });
                      }}
                    />
                  ))}
                </Tumbnail>
              </TumbContainer>
            </Modal>
          </>
        )}
      </Layout>
    </TimingAuctionContextProvider>
  );
};

DetailsPage.propTypes = {
  authentication: PropTypes.object.isRequired,
  auctionId: PropTypes.string.isRequired,
  auctionsActions: PropTypes.object.isRequired,
  eTrackingActions: PropTypes.object.isRequired,
  relatedDealers: PropTypes.array,
  user: PropTypes.object,
  history: PropTypes.object,
  bidError: PropTypes.bool,
  bidErrorMessage: PropTypes.string,
  selectAuction: PropTypes.func,
  auctionSelected: PropTypes.object,
};

const mapStateToProps = (
  {
    authentication,
    user: { relatedDealers },
    authentication: { user },
    auctions: { bidErrorMessage, bidError, detailedAuction, allAuctions },
  },
  { match }
) => ({
  authentication,
  auctionId: get(match, 'params.id'),
  relatedDealers,
  user,
  bidErrorMessage,
  bidError,
  auctionSelected: detailedAuction,
  allAuctions,
});

const mapDispatchToProps = dispatch => ({
  auctionsActions: bindActionCreators(AuctionsActions, dispatch),
  eTrackingActions: bindActionCreators(eventTrackingActions, dispatch),
  selectAuction: bindActionCreators(AuctionsActions.setSelectedAuction, dispatch),
  toggleModal: bindActionCreators(toggleModal, dispatch),
  listAutoBidVehicles: bindActionCreators(listAutoBidVehicles, dispatch),
  listAllAutoBidVehicles: bindActionCreators(listAllAutoBidVehicles, dispatch),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DetailsPage));
